import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
// import * as globalActions from '../redux/actions/globalActions';
// import PrismicReact from 'prismic-reactjs';
import MetaTags from '../components/MetaTags';
import HeroSection from '../components/Home/HeroSection';
// import MindfulnessSection from '../components/Home/MindfulnessSection';
import ProductSection from '../components/Home/ProductSection';
// import SubscribeSection from '../components/Home/SubscribeSection';
// import EventsSection from '../components/Home/EventsSection';
import AwardSection from '../components/Home/AwardSection';
import LoadingOverlay from '../components/LoadingOverlay';
// import Newsletter from '../components/Newsletter'
// import ModalNewsletter from '../components/ModalNewsletter';

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null,
      newsletterDoc: null,
      notFound: false,
    }
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'home_page') 
      let newsletterDoc = props.prismicData.results.find(result => result.type === 'modal_newsletter')

      this.setState({
        doc,
        newsletterDoc
      })
      props.getActiveDoc(doc)
    }
  }

 

	render() {
		if(this.state.doc && this.state.newsletterDoc) {
      let {
        prismicCtx,
      } = this.props

      const document = this.state.doc
      const docData = document.data
      // const newsletterDoc = this.state.newsletterDoc.data
      // console.log(document)

      return (
        <main id ="home" className="home">
          <MetaTags 
            title={`${docData.meta_title ? docData.meta_title : 'AltaVie'}`}
            description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
          />
          {/* {
            navigator.userAgent.indexOf('ReactSnap') <= 0 && 
              <ModalNewsletter
                doc={newsletterDoc}
                linkResolver={prismicCtx.linkResolver}
              />
          } */}
          {/* <ModalNewsletter
            doc={newsletterDoc}
            linkResolver={prismicCtx.linkResolver}
          /> */}
          {
            docData.body.map((slice, index) => {
              if(slice.slice_type === 'hero_section') {
                return (
                  <HeroSection
                    key={index}
                    slice={slice}
                    linkResolver={prismicCtx.linkResolver}
                  />
                )
              } 
              // else if(slice.slice_type === 'mindfulness_section') {
              //   return (
              //     <MindfulnessSection
              //       key={index}
              //       slice={slice}
              //       linkResolver={prismicCtx.linkResolver}
              //     />
              //   )
              // } 
              else if(slice.slice_type === 'product_feature_section') {
                return (
                  <ProductSection
                    key={index}
                    slice={slice}
                    linkResolver={prismicCtx.linkResolver}
                  />
                )
              } 
               // else if(slice.slice_type === 'subscribe_section') {
              //   return (
              //     <SubscribeSection
              //       key={index}
              //       slice={slice}
              //       linkResolver={prismicCtx.linkResolver}
              //     />
              //   )
              // } 
              // else if(slice.slice_type === 'events_section') {
              //   return (
              //     <EventsSection
              //       key={index}
              //       slice={slice}
              //       linkResolver={prismicCtx.linkResolver}
              //     />
              //   )
              // } 
              else if(slice.slice_type === 'award_section') {
                return (
                  <AwardSection
                    key={index}
                    slice={slice}
                    linkResolver={prismicCtx.linkResolver}
                  />
                )
              }
            })
          }
          {/* <div key={index} className="flex-item third footer-column footer-column-subscribe"> */}
            {/* <div className="column-content"> */}
              {/* <Newsletter locale /> */}
              <div className="newsletter">
                {/* {newsletterDoc.heading && PrismicReact.RichText.render(newsletterDoc.heading)}
                {newsletterDoc.blurb && PrismicReact.RichText.render(newsletterDoc.blurb, prismicCtx.linkResolver)} */}
                <div data-form-block-id={this.props.locale === "fr-ca" ? "3c9934ae-e36d-ea11-a811-000d3af3a7a7" : "796b45ff-e06d-ea11-a811-000d3af3a7a7"}></div>
              </div>
          {/* </div> */}
        </main>
      )
    } 
    return <LoadingOverlay/>
	}
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
  activeDoc: state.prismic.activeDoc,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { 
      getActiveDoc: prismicActions.getActiveDoc, 
      // toggleNewsletter: globalActions.toggleNewsletter,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Home)


// WEBPACK FOOTER //
// ./src/pages/Home.js